import { SPThunkAction } from "common/ReduxUtils";
import { transferCreateBulkUpdateLotNumbers } from "transfers/create/actions";
import { OrderItemDto } from "@deliverr/replenishment-client";
import { reduce } from "lodash";

export const updateOrderItemsLotNumber =
  (orderItems: OrderItemDto[]): SPThunkAction<void> =>
  async (dispatch) => {
    const lotDetails = reduce(
      orderItems,
      (acc, { lotNumber, dsku, expirationDate }) => {
        if (lotNumber) {
          acc[dsku] = {
            lotNumber,
            expirationDate,
          };
        }
        return acc;
      },
      {}
    );
    dispatch(transferCreateBulkUpdateLotNumbers(lotDetails));
  };
